import Actions from "./actions/actions";
import { ErrorToast } from "../../shared/index";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import { NotLogin, Loading, InfoToast } from "../../shared/index";
import React, { useState, useEffect } from "react";
import {
  ToPersianNumber,
  DateToPersianNumber,
  ErrorHandlingAPI,
} from "../../functions/index";

import { createDiscount, getDiscountCodes } from "../../api/requestAxios/discounts";
import GSPTable from '../../shared/GSFTable'
import { useNavigate } from "react-router";
import constants from "../../constants/constants";

function Promotions(props) {
  const [isComponentLoad, setIsComponentLoad] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [data, setData] = useState({ data: [] });
  const [dropDownFilter, setDropDownFilter] = useState("")
  const [argsTable, setArgsTable] = useState({
    disablePaging: false,
    filterList: [],
    pageNumber: 1,
    pageSize: 30,
    sortText: "StartDate desc",
    whereConditionText: ""
  })

  const navigate = useNavigate()

  const [coupon, setCoupon] = useState({
    allProductTypes: true,
    productLimitation: [],
    purchaseLimit: [1],
    contractTypeLimit: [1],
    code: null,
    applicationLimitCount: null,
    discountPercent: 0,
    maxDiscountAmount: null,
    persianStartDate: "",
    persianEndDate: "",

  })


  const rowNumberCompo = ({ item }) => {
    return (ToPersianNumber(item?.rowNumber))
  }
  const discountPercentCompo = ({ item }) => {
    return (item?.discountPercent ? ToPersianNumber(item?.discountPercent) : "۰")
  }
  const maxDiscountAmountCompo = ({ item }) => {
    return (item?.maxDiscountAmount ? ToPersianNumber(item?.maxDiscountAmount) : 'نامحدود')
  }
  const applicationLimitCountCompo = ({ item }) => {
    return (item?.applicationLimitCount ? ToPersianNumber(item?.applicationLimitCount) : 'نامحدود')
  }
  const persianStartDateCompo = ({ item }) => {
    return (item?.persianStartDate ? DateToPersianNumber(item?.persianStartDate.substring(0, 10)) : '---')
  }
  const persianEndDateCompo = ({ item }) => {
    return (item?.persianEndDate ? DateToPersianNumber(item?.persianEndDate.substring(0, 10)) : '---')
  }

  const viewDetailsCompo = ({ item }) => {
    return (<div className="view-detail-discount" onClick={() => {
      navigate('/promotion', { state: { id: item?.id, login: props?.login, usable: item?.usable } })
      setShowDetails(true)
    }
    }>مشاهده</div>)

  }
  const statusCompo = ({ item }) => {
    return (item?.usable ? <span style={{ color: 'green' }}>فعال</span> : <span style={{ color: 'red' }}>غیرفعال</span>)
  }


  const columns = [
    { title: 'ردیف', property: 'rowNumber', component: rowNumberCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'کد', property: 'code', filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'درصد', property: 'discountPercent', component: discountPercentCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'سقف مبلغ', property: 'maxDiscountAmount', component: maxDiscountAmountCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'سقف تعداد', property: 'applicationLimitCount', component: applicationLimitCountCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'وضعیت', property: 'usable', filterProperty: null, component: statusCompo, hasSort: false, hasFilter: false, display: true },
    { title: 'تاریخ ایجاد', property: 'persianStartDate', component: persianStartDateCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'تاریخ انقضا', property: 'persianEndDate', component: persianEndDateCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    { title: 'مشاهده', property: '', component: viewDetailsCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
  ]

  function stateClass(state) {
    if (state) return "enabled";
    return "disabled";
  }
  function stateText(state) {
    if (state) return Constants.Active;
    return Constants.InActive;
  }

  useEffect(() => {
    if (dropDownFilter !== "") {
      handelGetData()
    }
  }, [dropDownFilter])


  const handelGetData = async (args) => {
    setLoading(true);

    if (args) {
      args.sortText = "StartDate desc"
      args.pageSize = 30
      setArgsTable({ ...args })
    }

    try {
      const discountData = await getDiscountCodes({ filterAndSortConditions: args ? args : argsTable, enableStatus: dropDownFilter === "true" || dropDownFilter === "" ? true : false })
      setLoading(false);
      if (discountData.data) {
        if (discountData?.data?.data?.length > 0) {
          discountData?.data?.data?.forEach((item, index) => {
            item.rowNumber = index + 1
          })
        }
        let temp = { ...data };
        temp = discountData?.data
        setData({ ...temp });
      }

    }
    catch (error) {
      setLoading(false);
      ErrorToast(error);
    }



  }

  const createCoupons = async (data) => {
        try {
      setLoading(true);
      data?.productLimitation.forEach(element => {
        if (!element?.allProducts) {
          let temp = []
          element?.productIds.forEach(prd => {
            temp.push(prd?.productId)
            delete prd?.productName
            delete prd?.productId
          })
          element.productIds = temp
        }
      });
      const result = await createDiscount(data)
      if (!result?.data) {
        setShowModal(true)
        ErrorHandlingAPI(data)
      };
      if (result?.data) {
        InfoToast(constants.CouponCreatedSuccessFully);
        handelGetData()
        setShowModal(false)
        setCoupon({
          allProductTypes: true,
          productLimitation: [],
          purchaseLimit: [1],
          contractTypeLimit: [1],
          code: null,
          applicationLimitCount: null,
          discountPercent: 0,
          maxDiscountAmount: null,
          persianStartDate: "",
          persianEndDate: "",
        })
      }
      setLoading(false);
    }
    catch (err) {
      setLoading(false);
      ErrorToast(err)
      setShowModal(true)
    }

  }


  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-docs-container user-service-container mb-5 pb-5">
            <div className="user-info">
              {!showDetails && <Actions
                // handelGetData={handelGetData}
                Headings={Headings}
                token={props.token}
                createCoupons={createCoupons}
                login={props.login}
                dropDownFilter={dropDownFilter}
                setDropDownFilter={setDropDownFilter}
                showModal={showModal}
                setShowModal={setShowModal}
                setCoupon={setCoupon}
                coupon={coupon}
              ></Actions>}

              {!showDetails && <div className="divider"></div>}
              {
                !showDetails &&
                <GSPTable
                  columns={columns}
                  hasSorting={false}
                  apiCall={handelGetData}
                  dataList={data}
                  hasFiltering={false}
                  isSearchByExternalBtn={false}
                  hasPaging={true}
                  enableScrolling={false}
                  isStepScrolling={false}
                  pageSize={30}
                  loading={loading}
                />
              }


            </div>
          </div>
        </>
      )}
    </main>
  );
}
export default Promotions;
